// Public console addresses describe tasks. Service module routes stay internal.
const routes = [
  ['/hub/product-insights','/usage'], ['/hub/ips','/projects'], ['/hub/growth','/growth'], ['/hub/logs','/access-logs'],
  ['/fair/overview','/overview'], ['/fair/content','/content'], ['/fair/activities','/activities'],
  ['/fair/catalog','/catalog'], ['/fair/standards','/standards'], ['/fair/reviews','/releases'],
  ['/fair/orders','/orders'], ['/fair/production','/fulfillment'], ['/fair/settlements','/settlements'],
  ['/studio/api-registry','/runtime'], ['/studio/cost','/creation-cost'], ['/products/studio','/creation-jobs'],
  ['/hub','/content-admin'], ['/studio','/creation'], ['/fair','/commerce'],
] as const;

function translate(value:string, reverse:boolean) {
  for(const pair of routes) {
    const [from,to] = reverse ? [pair[1],pair[0]] : pair;
    if(value===from || value.startsWith(from+'/') || value.startsWith(from+'?') || value.startsWith(from+'#')) return to+value.slice(from.length);
  }
  return value;
}
export const consolePath=(path:string)=>translate(path,false);
export const modulePath=(path:string)=>translate(path,true);
